export default __webpack_public_path__ + "static/media/us-heart.87705854.png";